module.exports = __webpack_public_path__ + "static/media/calendar.0415d7b5.svg";